/* ============================================================
   Sticky add-to-cart (C2 / S3 + A4 + B5)
   Drives the theme's [data-variant-input] radios, not the no-js <select>.
   ============================================================ */
(function () {
  'use strict';

  var COMPARE_SECTION = '.whats-included-area';
  var COMPARE_PANE    = '.tab-pane';
  var MIN_PANES       = 2;

  function init() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar || bar.dataset.satcInit === '1') return;

    var realBtn   = document.querySelector('[data-add-to-cart]');
    var realSel   = document.querySelector('[data-product-select]');
    var realPrice = document.querySelector('[data-product-price]');
    if (!realBtn) return;

    bar.dataset.satcInit = '1';

    var barSel   = bar.querySelector('[data-sticky-select]');
    var barPrice = bar.querySelector('[data-sticky-price]');
    var barBtn   = bar.querySelector('[data-sticky-add]');
    var barText  = bar.querySelector('[data-sticky-add-text]');
    var realText = realBtn.querySelector('[data-add-to-cart-text]');

    /* ---------- price mirror (variant change AND the GOB Club toggle) ---------- */
    function syncPrice() {
      if (realPrice && barPrice) barPrice.innerHTML = realPrice.innerHTML;
    }
    if (realPrice && window.MutationObserver) {
      new MutationObserver(syncPrice).observe(realPrice, {
        childList: true, subtree: true, characterData: true
      });
    }

    /* ---------- button label + disabled mirror ---------- */
    function syncBtn() {
      if (realText && barText) barText.textContent = realText.textContent.trim();
      if (barBtn) barBtn.disabled = !!realBtn.disabled;
    }
    if (window.MutationObserver) {
      new MutationObserver(syncBtn).observe(realBtn, {
        childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['disabled', 'class']
      });
    }

    /* ---------- bar select -> theme radios ---------- */
    function applyVariant() {
      if (!barSel) return;
      var opt = barSel.options[barSel.selectedIndex];
      if (!opt) return;

      ['option1', 'option2', 'option3'].forEach(function (idx, i) {
        var want = opt.getAttribute('data-o' + (i + 1));
        if (!want) return;

        var radios = document.querySelectorAll('[data-variant-input][data-index="' + idx + '"]');
        for (var j = 0; j < radios.length; j++) {
          if (radios[j].value === want) {
            if (!radios[j].checked) {
              radios[j].click();
              radios[j].dispatchEvent(new Event('change', { bubbles: true }));
            }
            break;
          }
        }
      });

      if (realSel && realSel.value !== barSel.value) realSel.value = barSel.value;

      setTimeout(function () { syncPrice(); syncBtn(); }, 120);
      setTimeout(function () { syncPrice(); syncBtn(); }, 400);
    }

    if (barSel) barSel.addEventListener('change', applyVariant);

    /* ---------- theme radios -> bar select ---------- */
    document.addEventListener('change', function (e) {
      if (!barSel || !e.target || !e.target.hasAttribute) return;
      if (!e.target.hasAttribute('data-variant-input')) return;

      setTimeout(function () {
        if (realSel && realSel.value && barSel.value !== realSel.value) {
          barSel.value = realSel.value;
        }
        syncPrice(); syncBtn();
      }, 120);
    }, true);

    /* ---------- forward the click to the real button ---------- */
    if (barBtn) {
      barBtn.addEventListener('click', function (e) {
        e.preventDefault();
        realBtn.click();
      });
    }

    /* ---------- B5: compare versions, three-check guard ---------- */
    var cmpBtn = bar.querySelector('[data-sticky-compare]');
    if (cmpBtn) {
      var section = document.querySelector(COMPARE_SECTION);
      var panes   = section ? section.querySelectorAll(COMPARE_PANE) : [];

      if (section && panes.length >= MIN_PANES) {
        cmpBtn.hidden = false;

        cmpBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var offset = window.innerWidth < 750 ? 90 : 320;
          var y = section.getBoundingClientRect().top + window.pageYOffset - offset;

          bar.classList.add('is-hiding');
          window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
          setTimeout(function () { bar.classList.remove('is-hiding'); }, 900);
        });
      } else {
        // no comparison section on this page (accessories, quantity-only variants)
        cmpBtn.parentNode.removeChild(cmpBtn);
      }
    }

    /* ---------- show once the real button has scrolled past the top ---------- */
    function setVisible(on) {
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.body.classList.toggle('gob-satc-on', on);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          setVisible(!en.isIntersecting && en.boundingClientRect.top < 0);
        });
      }, { threshold: 0 }).observe(realBtn);
    } else {
      window.addEventListener('scroll', function () {
        setVisible(realBtn.getBoundingClientRect().bottom < 0);
      }, { passive: true });
    }

    syncPrice();
    syncBtn();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();